import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faFilePdf, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

interface BrochureModalProps {
  show: boolean;
  onHide: () => void;
  brochureUrl: string | null | undefined;
  courseTitle: string;
}

const BrochureModal: React.FC<BrochureModalProps> = ({ show, onHide, brochureUrl, courseTitle }) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered scrollable>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold">
          <FontAwesomeIcon icon={faFilePdf} className="text-danger me-2" />
          {courseTitle} - Brochure
        </Modal.Title>
      </Modal.Header>
      <Modal.Body 
        className="pt-0 position-relative" 
        onContextMenu={(e) => e.preventDefault()}
        style={{ userSelect: 'none', WebkitUserSelect: 'none' }}
      >
        {brochureUrl ? (
          <div style={{ height: '75vh', minHeight: '500px' }} className="mt-3 d-flex align-items-center justify-content-center bg-light rounded overflow-hidden position-relative">
            {brochureUrl.match(/\.(jpg|jpeg|png|gif|webp|svg)$/i) ? (
              <img 
                src={brochureUrl} 
                alt={`${courseTitle} Brochure`} 
                className="img-fluid rounded shadow-sm" 
                style={{ maxHeight: '100%', objectFit: 'contain' }}
                onDragStart={(e) => e.preventDefault()}
              />
            ) : (
              <iframe 
                src={`${brochureUrl}${brochureUrl.includes('?') ? '&' : '?'}#toolbar=0`}
                className="w-100 h-100 border-0" 
                title={`${courseTitle} Brochure`}
              />
            )}
          </div>
        ) : (
          <div className="text-center py-5">
            <FontAwesomeIcon icon={faExclamationCircle} size="4x" className="text-warning mb-3 opacity-50" />
            <h4 className="fw-bold">Brochure Not Available</h4>
            <p className="text-muted">The brochure for this course has not been added yet.</p>
            <Button variant="primary" className="mt-3 rounded-pill px-4" onClick={onHide}>
              Close
            </Button>
          </div>
        )}
      </Modal.Body>
      {brochureUrl && (
        <Modal.Footer className="border-0 pt-0">
          <Button variant="outline-secondary" onClick={onHide} className="rounded-pill px-4 mx-auto">
            Close
          </Button>
        </Modal.Footer>
      )}
      <style dangerouslySetInnerHTML={{ __html: `
        @media print {
          .modal-open { visibility: hidden !important; }
          .modal { display: none !important; }
        }
        .modal-body img {
          pointer-events: none;
        }
      `}} />
    </Modal>
  );
};

export default BrochureModal;
